import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { EmailTemplate, Templates } from '../models/emailTemplate';

export class EmailTemplateService extends BaseService<EmailTemplate> {
  override model = EmailTemplate;
  override modelName = 'emailTemplate';
  override modelLabel = 'Email Template';

  async templates(): Promise<ApiResponse<Templates>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/templates`,
    });

    return await this.requestItem(request, Templates);
  }

  async enable(
    emailTemplate: EmailTemplate,
  ): Promise<ApiResponse<EmailTemplate>> {
    const request = new ApiRequest({
      method: 'PUT',
      url: `${this.modelBaseUrl}/${emailTemplate.objectID()}`,
      data: { enabled: true },
    });

    return await this.requestItem(request, EmailTemplate);
  }

  async disable(
    emailTemplate: EmailTemplate,
  ): Promise<ApiResponse<EmailTemplate>> {
    const request = new ApiRequest({
      method: 'PUT',
      url: `${this.modelBaseUrl}/${emailTemplate.objectID()}`,
      data: { enabled: false },
    });

    return await this.requestItem(request, EmailTemplate);
  }

  async sendPreview(
    emailTemplate: EmailTemplate,
  ): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${emailTemplate.objectID()}/preview`,
      data: {
        type: emailTemplate.type,
        subject: emailTemplate.subject,
        htmlBody: emailTemplate.htmlBody,
      },
    });

    return await this.requestItem(request, EmailTemplate);
  }
}
